import axios, { AxiosResponse } from 'axios'

import { GuestDetailedRead, GuestRead, GuestSearchRead, GuestWrite } from '@generated/types'

const BASE_URL = '/api/guest'

export default {
  async search(options: {
    query: string
    field?: string
  }): Promise<AxiosResponse<GuestSearchRead[]>> {
    const params: { q: string; field?: string } = { q: options.query }
    if (options.field) {
      params.field = options.field
    }
    return axios.get(`${BASE_URL}/search/`, { params })
  },

  async fetchOneDetailed(id: number): Promise<AxiosResponse<GuestDetailedRead>> {
    return axios.get(`${BASE_URL}/${id}/reservations/`)
  },

  async update(data: GuestWrite): Promise<AxiosResponse<GuestRead>> {
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Guest ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async merge(sourceId: number, targetId: number): Promise<AxiosResponse<GuestRead>> {
    return axios.post(`${BASE_URL}/${sourceId}/merge-into/${targetId}/`)
  },
}
